class CollectionLiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('[data-collection-search-input]');
    this.debounceTimer = null;
    this.emptyMessage = null;

    if (!this.input) return;
    this.input.addEventListener('input', this.onInput.bind(this));
  }

  getGrid() {
    return document.querySelector('#product-grid');
  }

  onInput(e) {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.filter(e.target.value.trim().toLowerCase());
    }, 200);
  }

  filter(query) {
    const grid = this.getGrid();
    if (!grid) return;

    const items = grid.querySelectorAll('.grid__item:not(.collection-search__no-results)');
    let visibleCount = 0;

    items.forEach((item) => {
      const titleEl = item.querySelector('.card__heading');
      const vendorEl = item.querySelector('.caption-with-letter-spacing');
      const title = titleEl ? titleEl.textContent.trim().toLowerCase() : '';
      const vendor = vendorEl ? vendorEl.textContent.trim().toLowerCase() : '';
      const matches = !query || title.includes(query) || vendor.includes(query);

      item.style.display = matches ? '' : 'none';
      if (matches) visibleCount++;
    });

    this.toggleEmptyMessage(grid, visibleCount === 0 && query.length > 0);
  }

  toggleEmptyMessage(grid, show) {
    if (!this.emptyMessage) {
      this.emptyMessage = document.createElement('li');
      this.emptyMessage.className = 'collection-search__no-results';
      this.emptyMessage.textContent = 'Nenhum produto encontrado.';
      this.emptyMessage.style.display = 'none';
      grid.appendChild(this.emptyMessage);
    }
    this.emptyMessage.style.display = show ? '' : 'none';
  }
}

customElements.define('collection-live-search', CollectionLiveSearch);
